<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Directors List</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onDirectorCorrected()" *ngIf="rightItem && matchedItems && matchedItems.length > 0">
        <mat-icon>assignment_turned_in</mat-icon>
        Correct
      </button>
      <button mat-raised-button color="primary" (click)="toggleSearch()">
        <mat-icon>search</mat-icon>
        @if (isSearchVisible) { Close search } @else { Search @if (getAppliedFiltersCount() > 0) { ({{ getAppliedFiltersCount() }}) } }
      </button>
      <button mat-raised-button color="primary" (click)="onExportToCsv()">
        <mat-icon>insert_chart_outlined</mat-icon>
        CSV Export
      </button>
    </div>
  </div>
  <app-director-search-box
    [isSearchVisible]="isSearchVisible"
    [initialFilter]="currentSearchFilter"
    (directorSearchFilter)="onDirectorSearchFilterChange($event)"
    (showBoardMembershipsChange)="showBoardMemberships = $event">
  </app-director-search-box>
  <app-generic-list
    [items]="directors"
    [columnDefinitions]="columnDefinitions"
    [pageSize]="pageSize"
    [currentPage]="currentPage - 1"
    [pageSizeOptions]="[5, 10, 25, 50]"
    [totalItems]="totalItems"
    [serverSidePagination]="true"
    [enableMatching]="true"
    [enableEdit]="true"
    [enableLink]="true"
    linkTooltip="Open in new tab"
    [enableDelete]="true"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
    (editClick)="onEditDirector($event)"
    (linkClick)="onOpenDirectorInNewTab($event)"
    (readyToMatch)="onReadyToMatch($event)"
    (deleteClick)="onDeleteDirector($event)"
    (listItemClick)="onListItemClick($event)">
  </app-generic-list>
</div>
